module.exports = __webpack_public_path__ + "static/media/400-bottles-of-beer-thumb.a37d4444.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/beers/400-bottles-of-beer-thumb.jpg
// module id = 602
// module chunks = 0